<template>
  <header class="GigsPageHeader">
    <div class="GigsPageHeader__container container">
      <div class="GigsPageHeader-monthpicker">
        <div class="GigsPageHeader-monthpicker__title">
          <a
            :class="{ active: filterMonth === '' }"
            class="GigsPageHeader-monthpicker__all"
            href="#"
            @click.prevent="handleMonthFilterResetClick"
          >
            All Gigs
          </a>
        </div>

        <div
          v-for="(months, year) in monthsInFilter"
          :key="year"
          class="GigsPageHeader-monthpicker__year-group"
        >
          <span class="GigsPageHeader-monthpicker__year-group-year">
            {{ year }}:
          </span>

          <a
            v-for="month in months"
            :key="year + '-' + month"
            :class="{ active: filterMonth === getFirstDayOfMonthString(year, month)}"
            :data-date="getFirstDayOfMonthString(year, month)"
            class="GigsPageHeader-monthpicker__year-group-month"
            href="#"
            @click.prevent="handleMonthFilterClick"
          >
            {{ shortMonths[month] }}
          </a>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  props: {
    filterMonth: {
      default: '',
      type: String,
    },
    shortMonths: {
      default: () => ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      type: Array,
    },
  },
  computed: {
    monthsInFilter() {
      const monthsInFilter = {};
      const currentDate = new Date();

      // Get the next twelve months for the filter
      for (let i = 0; i < 12; i += 1) {
        if (!(`${currentDate.getFullYear()}` in monthsInFilter)) {
          monthsInFilter[`${currentDate.getFullYear()}`] = [];
        }
        monthsInFilter[`${currentDate.getFullYear()}`].push(`${currentDate.getMonth()}`);

        currentDate.setMonth(currentDate.getMonth() + 1);
      }

      return monthsInFilter;
    },
  },
  methods: {
    getFirstDayOfMonthString(year, month) {
      return `${year}-${String(parseInt(month, 10) + 1).padStart(2, '0')}-01`;
    },
    handleMonthFilterClick(event) {
      // Set filter state on parent component
      this.$parent.setFilterMonth(event.target.dataset.date);
    },
    handleMonthFilterResetClick() {
      // Reset filter state on parent component
      this.$parent.setFilterMonth('');
    },
  },
};
</script>
